export default {"src":"/_next/static/media/ev_charger.6aeb9e30.svg","height":100,"width":100};